import {
  getTeamMemberListData,
  _getTMDataById,
  _getTMSelectItemDataById,
} from '../teamMembers/mockData'
import {
  getProjectListData,
  _getProjSelectItemDataById,
} from '../projects/mockData'
import {
  getLocationListData,
  _getLSelectItemDataById,
} from '../locations/mockData'
import {
  getSupplierListData,
  _getSSelectItemDataById,
} from '../suppliers/mockData'
import { getTsdListData, _getTSelectItemDataById } from '../tsds/mockData'
import {
  getOpportunityListData,
  _getOSelectItemDataById,
} from '../opportunities/mockData'
import { getOrderListData, _getMOSelectItemDataById } from '../orders/mockData'
import {
  getCompanyContactListData,
  _getCCTDataById,
} from '../companyContacts/mockData'
import { getTsdContactListData, _getTCTDataById } from '../tsdContacts/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import {
  getSupplierContactListData,
  _getSCTDataById,
} from './../supplierContacts/mockData'
import { getPriorityById, PriorityIds } from '~/services/selectLists/priorities'
import {
  getCallStatusById,
  CallStatusIds,
} from '~/services/selectLists/callStatii'
import type { ICall } from '~/types/call/models'
import type { TEntityId } from '~/types/models'

const callListData = undefined as unknown as ICall[]

export const getCallListData = getListDataFunctionFactory<ICall[]>({
  listData: callListData,
  storageKey: 'calls',
  getStartingListData: getStartingCallListData,
  sortFunction: (a, b) => {
    if (b.createdAt < a.createdAt) {
      return -1
    }
    if (b.createdAt > a.createdAt) {
      return 1
    }
    return 0
  },
})

export async function getCallDataById(
  id: TEntityId
): Promise<ICall | undefined> {
  const list = await getCallListData()
  if (!list) {
    throw new Error(`callList returned undefined/null`)
  }
  return list.find((call: ICall) => call.id === id)
}

export async function getCallListDataByCompanyId(
  id: TEntityId
): Promise<ICall[]> {
  const list = await getCallListData()
  if (!list) {
    throw new Error(`callList returned undefined/null`)
  }
  return (
    list.filter(
      (call: ICall) =>
        call.company?.id === id || call.contact?.company?.id === id
    ) ?? []
  )
}

export async function getCallListDataByOpportunityId(
  id: TEntityId
): Promise<ICall[]> {
  const list = await getCallListData()
  if (!list) {
    throw new Error(`callList returned undefined/null`)
  }
  return list.filter((call: ICall) => call.opportunity?.id === id) ?? []
}

export async function getCallListDataByOrderId(
  id: TEntityId
): Promise<ICall[]> {
  const list = await getCallListData()
  if (!list) {
    throw new Error(`callList returned undefined/null`)
  }
  return list.filter((call: ICall) => call.order && call.order.id === id) ?? []
}

export async function getCallListDataByProjectId(
  id: TEntityId
): Promise<ICall[]> {
  const list = await getCallListData()
  if (!list) {
    throw new Error(`callList returned undefined/null`)
  }
  return (
    list.filter((call: ICall) => call.project && call.project.id === id) ?? []
  )
}

export async function getCallListDataByLocationId(
  id: TEntityId
): Promise<ICall[]> {
  const list = await getCallListData()
  if (!list) {
    throw new Error(`callList returned undefined/null`)
  }
  return (
    list.filter((call: ICall) => call.location && call.location.id === id) ?? []
  )
}

export async function getCallListDataByOwnerId(
  id: TEntityId
): Promise<ICall[]> {
  const list = await getCallListData()
  if (!list) {
    throw new Error(`callList returned undefined/null`)
  }
  const calls = list.filter((c: ICall) => c.owner && c.owner.id === id) ?? []
  return calls
}

export async function getCallListDataBySupplierId(
  id: TEntityId
): Promise<ICall[]> {
  const list = await getCallListData()
  if (!list) {
    throw new Error(`callList returned undefined/null`)
  }
  const calls =
    list.filter(
      (c: ICall) => c.supplier?.id === id || c.contact?.supplier?.id === id
    ) ?? []
  return calls
}

export async function getCallListDataByTsdId(id: TEntityId): Promise<ICall[]> {
  const list = await getCallListData()
  if (!list) {
    throw new Error(`callList returned undefined/null`)
  }
  const calls =
    list.filter((c: ICall) => c.tsd?.id === id || c.contact?.tsd?.id === id) ??
    []
  return calls
}

export async function getCallListDataByTeamMemberId(
  id: TEntityId
): Promise<ICall[]> {
  const list = await getCallListData()
  if (!list) {
    throw new Error(`callList returned undefined/null`)
  }
  const calls =
    list.filter((c: ICall) => c.owner?.id === id || c.assignedTo?.id === id) ??
    []
  return calls
}

export async function getStartingCallListData(): Promise<ICall[]> {
  const tmList = await getTeamMemberListData()
  const projList = await getProjectListData()
  const cctList = await getCompanyContactListData()
  const sctList = await getSupplierContactListData()
  const tctList = await getTsdContactListData()
  const locList = await getLocationListData()
  const oList = await getOpportunityListData()
  const moList = await getOrderListData()
  const tsdList = await getTsdListData()
  const sList = await getSupplierListData()

  return [
    {
      id: 'XXCL0001',
      hrid: 'CL0001',
      project: _getProjSelectItemDataById('XXP0002', projList),
      contact: _getCCTDataById('XXCCT0031', cctList),
      phone: '(555) 444-5555',
      descr: 'Scheduled DIA Install',
      notes: 'This is the first call associated with E-LAN Migration',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-01-02T17:15:00.000Z',
      endDateTime: '2023-01-02T17:16:30.000Z',
      owner: _getTMDataById('XXTM0001', tmList),
      status: getCallStatusById(CallStatusIds.OPEN),
      createdAt: '2023-01-02T17:15:00.000Z',
      modifiedAt: '2023-01-02T17:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0002',
      hrid: 'CL0002',
      project: _getProjSelectItemDataById('XXP0002', projList),
      contact: _getCCTDataById('XXCCT0031', cctList),
      phone: '(555) 444-5555',
      descr: 'Called Cogent re New Drop',
      notes: 'This is the second call associated with E-LAN Migration',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-02-02T18:15:00.000Z',
      endDateTime: '2023-02-02T18:15:45.000Z',
      owner: _getTMDataById('XXTM0003', tmList),
      status: getCallStatusById(CallStatusIds.CLOSED),
      createdAt: '2023-02-02T18:15:00.000Z',
      modifiedAt: '2023-02-02T18:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0003',
      hrid: 'CL0003',
      location: _getLSelectItemDataById('XXL0001', locList),
      contact: _getCCTDataById('XXCCT0001', cctList),
      phone: '(555) 444-5555',
      descr: 'Checked zoning issue',
      notes: 'This is the first call associated with this location',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-01-02T19:15:00.000Z',
      endDateTime: '2023-01-02T20:16:12.000Z',
      owner: _getTMDataById('XXTM0001', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0001', tmList),
      status: getCallStatusById(CallStatusIds.OPEN),
      createdAt: '2023-01-02T19:15:00.000Z',
      modifiedAt: '2023-01-02T19:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0004',
      hrid: 'CL0004',
      location: _getLSelectItemDataById('XXL0001', locList),
      contact: _getCCTDataById('XXCCT0002', cctList),
      phone: '(555) 444-5555',
      descr: 'Verified parking',
      notes: 'This is the second call associated with this location',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-01-02T20:15:00.000Z',
      endDateTime: '2023-01-02T22:13:00.000Z',
      owner: _getTMDataById('XXTM0001', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0001', tmList),
      status: getCallStatusById(CallStatusIds.CLOSED),
      createdAt: '2023-01-02T20:15:00.000Z',
      modifiedAt: '2023-01-02T20:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0005',
      hrid: 'CL0005',
      contact: _getCCTDataById('XXCCT0031', cctList),
      phone: '(555) 444-5555',
      descr: 'Verified SSN',
      notes: 'This is the first call associated with Robert Downy, Jr.',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-02-02T21:15:00.000Z',
      endDateTime: '2023-02-02T22:05:00.000Z',
      owner: _getTMDataById('XXTM0005', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0005', tmList),
      status: getCallStatusById(CallStatusIds.OPEN),
      createdAt: '2023-02-02T21:15:00.000Z',
      modifiedAt: '2023-01-02T21:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0006',
      hrid: 'CL0006',
      contact: _getCCTDataById('XXCCT0031', cctList),
      phone: '(555) 444-5555',
      descr: 'Got acnt for direct deposit',
      notes: 'This is the second call associated with Robert Downy, Jr.',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-01-02T22:15:00.000Z',
      endDateTime: '2023-01-02T22:24:00.000Z',
      owner: _getTMDataById('XXTM0005', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0005', tmList),
      status: getCallStatusById(CallStatusIds.CLOSED),
      createdAt: '2023-01-02T22:15:00.000Z',
      modifiedAt: '2023-01-02T22:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0007',
      hrid: 'CL0007',
      supplier: _getSSelectItemDataById('XXS0002', sList),
      contact: _getSCTDataById('XXSCT0002', sctList),
      phone: '(555) 444-5555',
      descr: 'Checked DIA availability',
      notes: 'This is the first call associated with Supplier Cogent',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-01-02T23:15:00.000Z',
      endDateTime: '2023-01-02T23:20:00.000Z',
      owner: _getTMDataById('XXTM0001', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0001', tmList),
      status: getCallStatusById(CallStatusIds.OPEN),
      createdAt: '2023-01-02T23:15:00.000Z',
      modifiedAt: '2023-01-02T23:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0008',
      hrid: 'CL0008',
      supplier: _getSSelectItemDataById('XXS0002', sList),
      contact: _getSCTDataById('XXSCT0002', sctList),
      phone: '(555) 444-5555',
      descr: 'Verified router model',
      notes: 'This is the second call associated with Supplier Cogent',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-02-03T00:15:00.000Z',
      endDateTime: '2023-02-03T01:17:00.000Z',
      owner: _getTMDataById('XXTM0003', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0003', tmList),
      status: getCallStatusById(CallStatusIds.CLOSED),
      createdAt: '2023-02-03T00:15:00.000Z',
      modifiedAt: '2023-02-28T00:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0009',
      hrid: 'CL0009',
      supplier: _getSSelectItemDataById('XXS0003', sList),
      contact: _getSCTDataById('XXSCT0003', sctList),
      phone: '(555) 444-5555',
      descr: 'Checked ETA on router',
      notes: 'This is the first call associated with Supplier Comcast',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-02-03T01:15:00.000Z',
      endDateTime: '2023-02-03T01:48:00.000Z',
      owner: _getTMDataById('XXTM0001', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0001', tmList),
      status: getCallStatusById(CallStatusIds.OPEN),
      createdAt: '2023-02-03T01:15:00.000Z',
      modifiedAt: '2023-02-28T01:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0010',
      hrid: 'CL0010',
      supplier: _getSSelectItemDataById('XXS0003', sList),
      contact: _getSCTDataById('XXSCT0003', sctList),
      phone: '(555) 444-5555',
      descr: 'Got new billing contact',
      notes: 'This is the second call associated with Supplier Comcast',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-02-03T02:15:00.000Z',
      endDateTime: '2023-02-03T02:26:00.000Z',
      owner: _getTMDataById('XXTM0003', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0003', tmList),
      status: getCallStatusById(CallStatusIds.CLOSED),
      createdAt: '2023-02-03T02:15:00.000Z',
      modifiedAt: '2023-02-28T02:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0011',
      hrid: 'CL0011',
      tsd: _getTSelectItemDataById('XXT0001', tsdList),
      contact: _getTCTDataById('XXTCT0002', tctList),
      phone: '(555) 444-5555',
      descr: 'Verified resells Verizon',
      notes: 'This is the first call associated with Tsd TBI',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-02-03T03:15:00.000Z',
      endDateTime: '2023-02-03T04:30:00.000Z',
      owner: _getTMDataById('XXTM0001', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0001', tmList),
      status: getCallStatusById(CallStatusIds.OPEN),
      createdAt: '2023-02-03T03:15:00.000Z',
      modifiedAt: '2023-02-28T03:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0012',
      hrid: 'CL0012',
      tsd: _getTSelectItemDataById('XXT0001', tsdList),
      contact: _getTCTDataById('XXTCT0002', tctList),
      phone: '(555) 444-5555',
      descr: 'Got new reps name',
      notes: 'This is the second call associated with Tsd TBI',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-01-02T17:15:00.000Z',
      endDateTime: '2023-01-02T18:03:00.000Z',
      owner: _getTMDataById('XXTM0003', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0003', tmList),
      status: getCallStatusById(CallStatusIds.CLOSED),
      createdAt: '2023-01-02T17:15:00.000Z',
      modifiedAt: '2023-01-02T17:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0013',
      hrid: 'CL0013',
      opportunity: _getOSelectItemDataById('XXO0003', oList),
      contact: _getCCTDataById('XXCCT0031', cctList),
      phone: '(555) 444-5555',
      descr: 'Got cust liaison name',
      notes: 'This is the first call associated with opportunity O00003',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-02-02T17:15:00.000Z',
      endDateTime: '2023-02-02T17:45:00.000Z',
      owner: _getTMDataById('XXTM0001', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0001', tmList),
      status: getCallStatusById(CallStatusIds.OPEN),
      createdAt: '2023-02-02T17:15:00.000Z',
      modifiedAt: '2023-02-02T17:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0014',
      hrid: 'CL0014',
      opportunity: _getOSelectItemDataById('XXO0003', oList),
      contact: _getCCTDataById('XXCCT0031', cctList),
      phone: '(555) 444-5555',
      descr: 'Checked DIA need',
      notes: 'This is the second call associated with opportunity O00003',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-03-01T17:15:00.000Z',
      endDateTime: '2023-03-01T17:35:00.000Z',
      owner: _getTMDataById('XXTM0003', tmList),
      status: getCallStatusById(CallStatusIds.CLOSED),
      createdAt: '2023-03-01T17:15:00.000Z',
      modifiedAt: '2023-03-01T17:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0015',
      hrid: 'CL0015',
      order: _getMOSelectItemDataById('XXORD0001', moList),
      contact: _getCCTDataById('XXCCT0031', cctList),
      phone: '(555) 444-5555',
      descr: 'Verified Boston access for install',
      notes: 'This is the first call associated with order ORD0003',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-02-02T17:15:00.000Z',
      endDateTime: '2023-02-02T18:15:00.000Z',
      owner: _getTMDataById('XXTM0001', tmList),
      assignedTo: _getTMSelectItemDataById('XXTM0001', tmList),
      status: getCallStatusById(CallStatusIds.OPEN),
      createdAt: '2023-02-02T17:15:00.000Z',
      modifiedAt: '2023-02-02T17:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCL0016',
      hrid: 'CL0016',
      order: _getMOSelectItemDataById('XXORD0001', moList),
      contact: _getCCTDataById('XXCCT0031', cctList),
      phone: '(555) 444-5555',
      descr: 'Verified Lake access for install',
      notes: 'This is the second call associated with order ORD0003',
      priority: getPriorityById(PriorityIds.MEDIUM),
      startDateTime: '2023-03-01T17:15:00.000Z',
      endDateTime: '2023-03-01T18:25:00.000Z',
      owner: _getTMDataById('XXTM0003', tmList),
      status: getCallStatusById(CallStatusIds.CLOSED),
      createdAt: '2023-03-01T17:15:00.000Z',
      modifiedAt: '2023-03-01T17:15:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
  ]
}
